export default "__VITE_ASSET__2TWV$013__"